export enum LocalStorageKey {
  TASKS = "taskly-tasks",
}
